import style from "./style.module.scss";
import type { FieldGroupProps } from "../../types";

function FieldGroup({ label, children }: FieldGroupProps) {
  return (
    <div className={style.container}>
      <h3 className={style.label}>{label}</h3>
      <div className={style.fields}>{children}</div>
    </div>
  );
}

export default FieldGroup;
